import { render, staticRenderFns } from "./ExEditTableForm.vue?vue&type=template&id=8006ace2&scoped=true"
import script from "./ExEditTableForm.vue?vue&type=script&lang=js"
export * from "./ExEditTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8006ace2",
  null
  
)

export default component.exports